import * as React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./navTab.module.scss";

const getInitialTab = (pathname = "", role = "", paramsData = {}) => {
  switch (pathname) {
    case "/order":
    case "/offer":
    case "/banner":
    case "/blog":
    case "/blogCategories":
    case "/cartBundleOrders":
    case "cartBundleOrdersPackager":
    case "cartBundleOrdersDispatcher":
    case "/products/productMgmt":
    case "/raiseTicket":
      return 0;

    case "/order/completed":
    case "/cartBundleOrders/completed":
    case "/cartBundleOrdersPackager/completed":
    case "/cartBundleOrdersDispatcher/inTransit":
    case "/offer/inActive":
    case "/banner/inActive":
    case "/blog/inActive":
    case "/blogCategories/inActive":
    case "/packagerorder/packagercompleted":
    case "/products/productMgmt/disabled":
    case "/dispatcherorder/intransit":
    case "/raiseTicket/completed":
      return 1;
    case "/dispatcherorder/dispatchercompleted":
    case "/cartBundleOrdersDispatcher/completed":
    case "/products/productMgmt/deleted":
    case "/shipment-orders/in-progress":
      return 2;
    case "/shipment-orders/completed":
      return 3;

    case "/admin-panel/wi-orders":
      return 0;
    default:
      return 0;
  }
};

export default function NavTabs({
  data = [],
  variant,
  centeredValue,
  disabledValue,
  iconPosition,
  role,
  paramsData,
  selected,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = React.useState(
    getInitialTab(location.pathname, role)
  );

  React.useEffect(() => {
    setValue(getInitialTab(location.pathname, role, paramsData));
  }, [role, location.pathname]);

  const handleChange = (event, newValue) => {
    if (data[newValue]?.link) {
      navigate(data[newValue]?.link);
    }
  };

  return (
    <Tabs
      value={value}
      onChange={handleChange}
      aria-label="nav tabs example"
      variant={variant}
      centered={centeredValue}
      classes={{ root: styles.tabStyle }}
      TabIndicatorProps={{ style: { display: "none" } }}
    >
      {data.map((item) => (
        <Tab
          icon={item.icon}
          iconPosition={iconPosition}
          label={item.title}
          disabled={disabledValue}
          key={item.id}
          classes={{ selected: styles.selected }}
        />
      ))}
    </Tabs>
  );
}
